import {
    SET_CASH_TRANSACTIONS, 
    SET_CALCULATOR,
    SET_QUESTIONS, 
    SET_LOADING,
    STOP_LOADING,
    SET_BACKBTN
  } from "../actions/types";
  
  
  const initialState = {
     creditTerm: null,
     status: null,
     cashTransactions: {
         cashInvestment: 0,
         cashAvailable: 0
     },
     calculator: {
        rate: 0,
        principal: 0,
        rateTerm: 'Weekly',
        term: 0,
        amortization: 0,
        total: 0
     },
     questions: [],
     loading: false,
     backBtn: null
  }
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
  
    switch (type) {
      case SET_BACKBTN:
        return {
          ...state,
          backBtn: payload  
        };
      case SET_CASH_TRANSACTIONS:
        return {
          ...state,
          cashTransactions: { ...state.cashTransactions, ...payload}  
        };
        case SET_CALCULATOR:
          let calc = { ...state.calculator, ...payload };
          let ttRate = Number(calc.rate  * calc.term) + 1;
        let total = Number(calc.principal * ttRate).toFixed(2);
        let amortization = Number(total / calc.term).toFixed(2);

          return {
            ...state,
            calculator: { ...calc, total, amortization }  
          };
          case SET_QUESTIONS:
            return {
              ...state,
              questions: payload  
            };    
            case SET_LOADING:
              return {
                ...state,
              loading: true  
              };
              case STOP_LOADING:
                return {
                  ...state,
                  loading: false  
                };        
      default:
        return state;
    }
  }